"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SynchronizeArrow: ['synchronize-arrow', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.567,1.255A10.822,10.822,0,0,0,2.818,8.392a.248.248,0,0,1-.271.162L.858,8.305a.516.516,0,0,0-.485.213.5.5,0,0,0-.021.531l2.679,4.7a.5.5,0,0,0,.367.247.491.491,0,0,0,.067,0,.5.5,0,0,0,.352-.146l3.77-3.746a.5.5,0,0,0-.279-.849L5.593,9a.251.251,0,0,1-.192-.35,8.259,8.259,0,1,1,7.866,11.59A8.219,8.219,0,0,1,6.31,16.879,1.25,1.25,0,0,0,4.3,18.359a10.752,10.752,0,0,0,8.667,4.391c.132,0,.265,0,.4-.008a10.751,10.751,0,1,0-.792-21.487Z']],
  SynchronizeArrow1: ['synchronize-arrow-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.567,1.258A10.822,10.822,0,0,0,2.818,8.4a.25.25,0,0,1-.271.163L.858,8.309a.514.514,0,0,0-.485.213.5.5,0,0,0-.021.53l2.679,4.7a.5.5,0,0,0,.786.107l3.77-3.746a.5.5,0,0,0-.279-.85L5.593,9.007a.25.25,0,0,1-.192-.35,8.259,8.259,0,1,1,7.866,11.59,1.25,1.25,0,0,0,.045,2.5h.047a10.751,10.751,0,1,0-.792-21.487Z']],
  SynchronizeArrowClock: ['synchronize-arrow-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.965,6a1,1,0,0,0-1,1v5.5a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2h-3.75a.25.25,0,0,1-.25-.25V7A1,1,0,0,0,12.965,6Z', 'M12.567,1.258A10.822,10.822,0,0,0,2.818,8.4a.25.25,0,0,1-.271.163L.858,8.309a.514.514,0,0,0-.485.213.5.5,0,0,0-.021.53l2.679,4.7a.5.5,0,0,0,.786.107l3.77-3.746a.5.5,0,0,0-.279-.85L5.593,9.007a.25.25,0,0,1-.192-.35,8.259,8.259,0,1,1,7.866,11.59,1.25,1.25,0,0,0,.045,2.5h.047a10.751,10.751,0,1,0-.792-21.487Z']],
  SynchronizeArrowsSquare: ['synchronize-arrows-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,5.248h4.25A.25.25,0,0,1,11,5.5v1a.5.5,0,0,0,.288.453A.507.507,0,0,0,11.5,7a.494.494,0,0,0,.32-.116l3-2.5a.5.5,0,0,0,0-.768l-3-2.5A.5.5,0,0,0,11,1.5v1a.25.25,0,0,1-.25.25H6.5A4.255,4.255,0,0,0,2.25,7V17a4.255,4.255,0,0,0,4.25,4.25,1.25,1.25,0,0,0,0-2.5A1.752,1.752,0,0,1,4.75,17V7A1.752,1.752,0,0,1,6.5,5.248Z', 'M12.18,22.882A.494.494,0,0,0,12.5,23a.507.507,0,0,0,.212-.047A.5.5,0,0,0,13,22.5v-1a.25.25,0,0,1,.25-.25H17.5A4.255,4.255,0,0,0,21.75,17V7a4.255,4.255,0,0,0-4.25-4.25,1.25,1.25,0,0,0,0,2.5A1.752,1.752,0,0,1,19.25,7V17a1.752,1.752,0,0,1-1.75,1.75H13.25A.25.25,0,0,1,13,18.5v-1a.5.5,0,0,0-.82-.384l-3,2.5a.5.5,0,0,0,0,.768Z']],
  SynchronizeArrowsLock: ['synchronize-arrows-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.988,7.248A2.752,2.752,0,0,0,9.238,10v.873a.251.251,0,0,1-.15.23.977.977,0,0,0-.6.9v3a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V12a.977.977,0,0,0-.6-.9.251.251,0,0,1-.15-.23V10A2.752,2.752,0,0,0,11.988,7.248Zm0,1.5A1.25,1.25,0,0,1,13.238,10v.75a.25.25,0,0,1-.25.25h-2a.25.25,0,0,1-.25-.25V10A1.251,1.251,0,0,1,11.988,8.748Zm0,5.75a1,1,0,1,1,1-1A1,1,0,0,1,11.988,14.5Z', 'M.077,10.319l2.589,4.54a.5.5,0,0,0,.372.248.444.444,0,0,0,.063,0,.5.5,0,0,0,.359-.152L7.1,11.2a.5.5,0,0,0-.3-.844L4.758,10.1a.251.251,0,0,1-.2-.332A8.1,8.1,0,0,1,10.23,4.559a7.616,7.616,0,0,1,7.479,2.373,1.25,1.25,0,1,0,1.872-1.657A10.122,10.122,0,0,0,9.655,2.126,10.673,10.673,0,0,0,1.982,9.565a.218.218,0,0,1-.237.157L.575,9.575a.5.5,0,0,0-.5.744Z', 'M23.488,14.41a.5.5,0,0,0,.433-.75L21.305,9.134a.5.5,0,0,0-.373-.246.487.487,0,0,0-.421.15L16.9,12.816a.5.5,0,0,0,.3.842l2.01.241a.25.25,0,0,1,.206.332,8.1,8.1,0,0,1-5.672,5.206,7.625,7.625,0,0,1-7.481-2.374,1.251,1.251,0,0,0-1.872,1.659,10.143,10.143,0,0,0,9.929,3.149,10.673,10.673,0,0,0,7.669-7.426.249.249,0,0,1,.27-.179l1.17.14A.4.4,0,0,0,23.488,14.41Z']],
  SynchronizeArrowsSearch: ['synchronize-arrows-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.639,15.735a.489.489,0,0,0,.171.858l4.712,1.29a.518.518,0,0,0,.129.016.487.487,0,0,0,.489-.5l-.08-4.887a.489.489,0,0,0-.789-.377L3.816,13.268a.249.249,0,0,1-.379-.091,7.519,7.519,0,0,1,.327-7.095,7.053,7.053,0,0,1,6.464-3.35A1.222,1.222,0,1,0,10.377.293,9.551,9.551,0,0,0,1.686,4.8a10.028,10.028,0,0,0-.181,10,.25.25,0,0,1-.066.318Z', 'M15.831,13.538a7.067,7.067,0,0,1-6.464,3.35,1.222,1.222,0,1,0-.149,2.439c.2.012.39.018.585.018a9.5,9.5,0,0,0,5.637-1.859.249.249,0,0,1,.324.024l5.894,5.854A1.222,1.222,0,0,0,23.38,21.63l-5.887-5.847a.249.249,0,0,1-.024-.327c.155-.205.3-.414.441-.635a10.025,10.025,0,0,0,.176-10.007.249.249,0,0,1,.065-.317l.815-.641A.488.488,0,0,0,18.791,3L14.069,1.737a.484.484,0,0,0-.428.088.489.489,0,0,0-.187.4L13.563,7.1a.489.489,0,0,0,.281.431.475.475,0,0,0,.208.047.487.487,0,0,0,.3-.1l1.425-1.119a.254.254,0,0,1,.213-.047.249.249,0,0,1,.168.137A7.51,7.51,0,0,1,15.831,13.538Z']],
  SynchronizeArrowsThree: ['synchronize-arrows-three', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.985,20.57a1.25,1.25,0,0,0,.613,2.424,10.482,10.482,0,0,0,7.657-8.218.251.251,0,0,1,.223-.2l1.691-.152a.5.5,0,0,0,.326-.833l-3.2-3.55a.527.527,0,0,0-.417-.163.5.5,0,0,0-.38.235l-2.512,4.065a.5.5,0,0,0,.425.762l.045,0,.838-.075a.249.249,0,0,1,.261.323A7.92,7.92,0,0,1,12.985,20.57Z', 'M8.23,2.754a.25.25,0,0,1-.28-.111L7.079,1.2a.5.5,0,0,0-.891.072L4.4,5.707a.5.5,0,0,0,.414.684l4.753.473a.419.419,0,0,0,.05,0,.5.5,0,0,0,.428-.759l-.458-.756a.25.25,0,0,1,.175-.376,7.906,7.906,0,0,1,7.309,2.677,1.25,1.25,0,1,0,1.908-1.615A10.427,10.427,0,0,0,8.23,2.754Z', 'M2.558,8.746a1.245,1.245,0,0,0-1.595.762A10.493,10.493,0,0,0,3.545,20.456a.25.25,0,0,1,.045.3l-.8,1.47a.5.5,0,0,0,.439.739.6.6,0,0,0,.073-.005l4.727-.692a.5.5,0,0,0,.382-.7L6.421,17.219a.5.5,0,0,0-.437-.292.489.489,0,0,0-.457.261l-.424.781a.25.25,0,0,1-.414.039A7.966,7.966,0,0,1,3.32,10.342,1.25,1.25,0,0,0,2.558,8.746Z']],
  SynchronizeArrows: ['synchronize-arrows', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.743,2.5A10.269,10.269,0,0,0,2.378,9.61a.249.249,0,0,1-.271.178l-1.033-.13A.491.491,0,0,0,.6,9.877a.5.5,0,0,0-.019.526l2.476,4.342a.5.5,0,0,0,.373.248.43.43,0,0,0,.062,0,.5.5,0,0,0,.359-.152l3.477-3.593a.5.5,0,0,0-.3-.844L5.15,10.172a.25.25,0,0,1-.2-.333,7.7,7.7,0,0,1,5.373-4.9,7.239,7.239,0,0,1,7.1,2.252,1.25,1.25,0,1,0,1.872-1.657A9.737,9.737,0,0,0,9.743,2.5Z', 'M4.789,16.7a1.249,1.249,0,0,0-.107,1.764,9.74,9.74,0,0,0,9.549,3.03,10.261,10.261,0,0,0,7.369-7.12.251.251,0,0,1,.27-.179l1.058.127a.422.422,0,0,0,.06,0,.5.5,0,0,0,.433-.75l-2.5-4.329A.5.5,0,0,0,20.546,9a.489.489,0,0,0-.421.151l-3.456,3.614a.5.5,0,0,0,.3.842l1.848.221a.249.249,0,0,1,.183.117.253.253,0,0,1,.023.216,7.688,7.688,0,0,1-5.369,4.9,7.243,7.243,0,0,1-7.1-2.253A1.248,1.248,0,0,0,4.789,16.7Z', 'M9.488 11.998 A2.500 2.500 0 1 0 14.488 11.998 A2.500 2.500 0 1 0 9.488 11.998 Z']],
  SynchronizeArrowsSquareWarning: ['synchronize-arrows-square-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,21.748H17a4.255,4.255,0,0,0,4.25-4.25,1.25,1.25,0,0,0-2.5,0A1.752,1.752,0,0,1,17,19.248H7A1.753,1.753,0,0,1,5.25,17.5v-4.25A.25.25,0,0,1,5.5,13h1a.5.5,0,0,0,.384-.82l-2.5-3a.5.5,0,0,0-.769,0l-2.5,3A.5.5,0,0,0,1.5,13h1a.249.249,0,0,1,.25.25V17.5A4.255,4.255,0,0,0,7,21.748Z', 'M22.884,11.818A.5.5,0,0,0,22.5,11h-1a.25.25,0,0,1-.25-.25V6.5A4.255,4.255,0,0,0,17,2.248H7A4.255,4.255,0,0,0,2.75,6.5a1.25,1.25,0,1,0,2.5,0A1.753,1.753,0,0,1,7,4.748H17A1.752,1.752,0,0,1,18.75,6.5v4.25a.25.25,0,0,1-.25.25h-1a.5.5,0,0,0-.384.82l2.5,3a.5.5,0,0,0,.768,0Z', 'M12,12.978a1,1,0,0,0,1-1V8a1,1,0,0,0-2,0v3.98A1,1,0,0,0,12,12.978Z', 'M10.750 15.728 A1.250 1.250 0 1 0 13.250 15.728 A1.250 1.250 0 1 0 10.750 15.728 Z']],
  SynchronizeArrowsSquare1: ['synchronize-arrows-square-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,21.748H17a1.25,1.25,0,0,0,0-2.5H7A1.753,1.753,0,0,1,5.25,17.5v-4.25A.25.25,0,0,1,5.5,13h1a.5.5,0,0,0,.384-.82l-2.5-3a.5.5,0,0,0-.769,0l-2.5,3A.5.5,0,0,0,1.5,13h1a.249.249,0,0,1,.25.25V17.5A4.255,4.255,0,0,0,7,21.748Z', 'M20,15a.5.5,0,0,0,.384-.18l2.5-3A.5.5,0,0,0,22.5,11h-1a.25.25,0,0,1-.25-.25V6.5A4.255,4.255,0,0,0,17,2.248H7a1.25,1.25,0,0,0,0,2.5H17A1.752,1.752,0,0,1,18.75,6.5v4.25a.25.25,0,0,1-.25.25h-1a.5.5,0,0,0-.384.82l2.5,3A.5.5,0,0,0,20,15Z']],
  SynchronizeArrowsSquare2: ['synchronize-arrows-square-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7,21.748H17a4.255,4.255,0,0,0,4.25-4.25,1.25,1.25,0,0,0-2.5,0A1.752,1.752,0,0,1,17,19.248H7A1.753,1.753,0,0,1,5.25,17.5v-4.25A.25.25,0,0,1,5.5,13h1a.5.5,0,0,0,.384-.82l-2.5-3a.5.5,0,0,0-.769,0l-2.5,3A.5.5,0,0,0,1.5,13h1a.249.249,0,0,1,.25.25V17.5A4.255,4.255,0,0,0,7,21.748Z', 'M22.884,11.818A.5.5,0,0,0,22.5,11h-1a.25.25,0,0,1-.25-.25V6.5A4.255,4.255,0,0,0,17,2.248H7A4.255,4.255,0,0,0,2.75,6.5a1.25,1.25,0,1,0,2.5,0A1.753,1.753,0,0,1,7,4.748H17A1.752,1.752,0,0,1,18.75,6.5v4.25a.25.25,0,0,1-.25.25h-1a.5.5,0,0,0-.384.82l2.5,3a.5.5,0,0,0,.768,0Z']],
  SynchronizeArrow2: ['synchronize-arrow-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.567,1.257A10.821,10.821,0,0,0,2.818,8.4a.25.25,0,0,1-.271.162L.858,8.308a.516.516,0,0,0-.485.213.5.5,0,0,0-.021.53l2.679,4.7A.5.5,0,0,0,3.4,14c.022,0,.044,0,.067,0a.5.5,0,0,0,.352-.145l3.77-3.746a.5.5,0,0,0-.279-.85L5.593,9.006a.246.246,0,0,1-.183-.127A.25.25,0,0,1,5.4,8.656a8.259,8.259,0,1,1,7.866,11.591,1.25,1.25,0,0,0,.045,2.5h.047a10.751,10.751,0,0,0-.792-21.488Z', 'M10.465 12.002 A2.500 2.500 0 1 0 15.465 12.002 A2.500 2.500 0 1 0 10.465 12.002 Z']],
  SynchronizeArrowsWarning: ['synchronize-arrows-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.988,12.965a1,1,0,0,0,1-1V7.985a1,1,0,1,0-2,0v3.98A1,1,0,0,0,11.988,12.965Z', 'M10.738 15.715 A1.250 1.250 0 1 0 13.238 15.715 A1.250 1.250 0 1 0 10.738 15.715 Z', 'M19.292,5.531A9.736,9.736,0,0,0,9.743,2.5,10.269,10.269,0,0,0,2.378,9.61a.249.249,0,0,1-.271.178l-1.033-.13A.491.491,0,0,0,.6,9.877a.5.5,0,0,0-.019.526l2.476,4.342a.5.5,0,0,0,.373.248.43.43,0,0,0,.062,0,.5.5,0,0,0,.359-.152l3.477-3.593a.5.5,0,0,0-.3-.844L5.15,10.172a.25.25,0,0,1-.2-.333,7.7,7.7,0,0,1,5.373-4.9,7.238,7.238,0,0,1,7.1,2.252,1.25,1.25,0,1,0,1.872-1.657Z', 'M4.789,16.7a1.249,1.249,0,0,0-.107,1.764,9.74,9.74,0,0,0,9.549,3.03,10.261,10.261,0,0,0,7.369-7.12.251.251,0,0,1,.27-.179l1.058.127a.422.422,0,0,0,.06,0,.5.5,0,0,0,.433-.75l-2.5-4.329A.5.5,0,0,0,20.546,9a.489.489,0,0,0-.421.151l-3.456,3.614a.5.5,0,0,0,.3.842l1.848.221a.249.249,0,0,1,.183.117.253.253,0,0,1,.023.216,7.688,7.688,0,0,1-5.369,4.9,7.243,7.243,0,0,1-7.1-2.253A1.248,1.248,0,0,0,4.789,16.7Z']],
  SynchronizeArrows1: ['synchronize-arrows-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.319,4.936a7.239,7.239,0,0,1,7.1,2.252,1.25,1.25,0,1,0,1.872-1.657A9.737,9.737,0,0,0,9.743,2.5,10.269,10.269,0,0,0,2.378,9.61a.249.249,0,0,1-.271.178l-1.033-.13A.491.491,0,0,0,.6,9.877a.5.5,0,0,0-.019.526l2.476,4.342a.5.5,0,0,0,.373.248.43.43,0,0,0,.062,0,.5.5,0,0,0,.359-.152l3.477-3.593a.5.5,0,0,0-.3-.844L5.15,10.172a.25.25,0,0,1-.2-.333A7.7,7.7,0,0,1,10.319,4.936Z', 'M23.406,14.1a.5.5,0,0,0,.015-.526l-2.5-4.329A.5.5,0,0,0,20.546,9a.489.489,0,0,0-.421.151l-3.456,3.614a.5.5,0,0,0,.3.842l1.848.221a.249.249,0,0,1,.183.117.253.253,0,0,1,.023.216,7.688,7.688,0,0,1-5.369,4.9,7.243,7.243,0,0,1-7.1-2.253,1.25,1.25,0,1,0-1.872,1.656,9.74,9.74,0,0,0,9.549,3.03,10.261,10.261,0,0,0,7.369-7.12.251.251,0,0,1,.27-.179l1.058.127a.422.422,0,0,0,.06,0A.5.5,0,0,0,23.406,14.1Z']],
  SynchronizeArrowsTriangle: ['synchronize-arrows-triangle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.844,4.563l-1.424.7a.249.249,0,0,1-.33-.1L13.982,1.327a2.251,2.251,0,0,0-3.944,0L6.93,6.972a1.25,1.25,0,1,0,2.19,1.2l2.67-4.85a.25.25,0,0,1,.438,0l1.609,2.928a.25.25,0,0,1-.109.344l-.975.482a.5.5,0,0,0,.056.92l3.724,1.306a.481.481,0,0,0,.165.028A.5.5,0,0,0,17.169,9l1.367-3.824a.5.5,0,0,0-.692-.616Z', 'M19.791,11.9A1.25,1.25,0,1,0,17.6,13.1l3.082,5.611a.249.249,0,0,1-.219.37H17.1a.25.25,0,0,1-.25-.25v-1.5a.5.5,0,0,0-.306-.461.505.505,0,0,0-.544.1l-3.063,3a.5.5,0,0,0,0,.715l3.063,3a.5.5,0,0,0,.35.142.484.484,0,0,0,.194-.039.5.5,0,0,0,.306-.461v-1.5a.25.25,0,0,1,.25-.25h4.209a2.25,2.25,0,0,0,1.972-3.333Z', 'M.754,20.481a2.263,2.263,0,0,0,1.937,1.1H9a1.25,1.25,0,1,0,0-2.5H3.537a.25.25,0,0,1-.219-.37l2.133-3.874a.249.249,0,0,1,.352-.09l.9.568a.507.507,0,0,0,.267.077.5.5,0,0,0,.488-.609L6.6,10.928a.5.5,0,0,0-.592-.381l-3.941.838a.5.5,0,0,0-.163.912l1.352.852a.25.25,0,0,1,.086.332L.72,18.25A2.264,2.264,0,0,0,.754,20.481Z']]
};
exports["default"] = _default;